import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet } from 'react-router-dom';
import * as Yup from 'yup';

export const PURPOSE_TYPES = ['emergency_fund', 'retirement', 'major_purchase'] as const;
export type PurposeType = (typeof PURPOSE_TYPES)[number];

export const selection = Yup.object({
  purposeType: Yup.string().oneOf(PURPOSE_TYPES).required(),
});

export const assignment = Yup.object({
  purposeId: Yup.string(),
});

export const PURPOSE_SELECTION_FLOW_CONFIG = createConfig({
  selection: {
    schema: selection,
    dependencies: Yup.object({}),
  },
  assignment: {
    schema: assignment,
    dependencies: Yup.object({
      selection,
    }),
  },
});

export const { FlowProvider, useStep: usePurposeSelectionStep } = createFlowContext(PURPOSE_SELECTION_FLOW_CONFIG);

export const PurposeSelectionFlow = () => {
  return (
    <FlowProvider>
      <Outlet />
    </FlowProvider>
  );
};
